import { IconPropsInterface } from "./typings";

export default function MDIcons({ icon, className = "", outline = false }: IconPropsInterface) {
    return (<i className={`mdi mdi-${icon}${outline ? "-outline" : ""} ${className}`}></i>);
}
